var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productstation"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("加载中...")]):(_vm.productContent)?_c('div',{staticClass:"imgbox",domProps:{"innerHTML":_vm._s(_vm.productContent)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }